import { useQuery, useMutation } from 'react-query';
import { reportApi } from '../services/api';
import type { ReportFilter, ExportRequest } from '../types';

export interface UserReportResponse {
  userId: string;
  userName: string;
  summary: {
    totalExpenses: number;
    totalInvoices: number;
    expenseCount: number;
    invoiceCount: number;
  };
  projectBreakdown: Array<{
    projectId: string;
    projectName: string;
    totalExpenses: number;
    totalInvoices: number;
    margin: number;
  }>;
  records: Array<{
    type: 'expense' | 'invoice';
    id: string;
    date: string;
    amount: number;
    description: string;
    projectName: string;
    provider?: string;
    clientName?: string;
  }>;
}

export function useCategoryReport(filters?: ReportFilter) {
  return useQuery(
    ['reports', 'category', filters],
    () => reportApi.getCategoryReport(filters),
    {
      enabled: true,
      staleTime: 30000, // 30 seconds
    }
  );
}

export function useTimeReport(periodType: string, filters?: ReportFilter) {
  return useQuery(
    ['reports', 'time', periodType, filters],
    () => reportApi.getTimeReport(periodType, filters),
    {
      enabled: !!periodType,
      staleTime: 30000,
    }
  );
}

export function useExportReport() {
  return useMutation((request: ExportRequest) => reportApi.exportReport(request));
}

export function useUserReport(userId: string | null, startDate?: string, endDate?: string) {
  return useQuery(
    ['reports', 'user', userId, startDate, endDate],
    () => reportApi.getUserReport(userId!, startDate, endDate),
    {
      enabled: !!userId,
      staleTime: 30000,
    }
  );
}
